import React, { useState } from "react";
import { NavLink } from "react-router-dom";

function GetUsluga(usluga) {
  switch (usluga.type) {
    case "2":
      return (
        "Изменения"
      );
      break;
    case "3":
      return "Первичка"
      break;
    case "4":
      return "Ликвидация"
      break;
    case "5":
      return "Подача необходимых документов в регистрирующий орган и получение документов, подтверждающих гос. регистрацию уведомления о составлении промежуточного баланса, ликвидационного баланса, а также документов, подтверждающих регистрацию прекращения деятельности Общества";
      break;
    case "6":
      return "Содействие в получении справок о состоянии расчетов Общества с налоговой инспекцией, пенсионным фондом и фондом социального страхования";
      break;
    case "7":
      return "ЭЦП";
      break;
    case "8":
      return "Адрес";
      break;
    case "9":
      return "Представительство в банках и гос. органах";
      break;
    case "10":
      return "Консультация";
      break;
    case "11":
      return "Пробирка";
      break;
    case "12":
      return (
        "Подача в налоговую"
      );
      break;
    case "13":
      return usluga.other;
      break;
    default:
      return "";
  }
}

export const CardList = ({  CardEdit, cards, SaveCard , DeleteCard }) => {
    // const [formed, setFormed] = useState(true)
    // const [notFormed, setNotFormed] = useState(true)

  if (!cards.length) {
    return <p className="center">Карточек пока нет</p>;
  }
  return (
    <div>
      {/* <div>
        <p>Статус карточки: </p>
        <p>
          <label>
            <input onChange={()=>{
                setFormed(!formed)
            }} type="checkbox" className="black filled-in" checked={formed} />
            <span style={{color: "white"}} className="left badge green">Оформлена</span>
          </label>
        </p>
        <p>
          <label>
            <input onChange={()=>{
                setNotFormed(!notFormed)
            }} type="checkbox" className="black filled-in" checked={notFormed} />
            <span style={{color: "white"}} className="left badge red">Не оформлена</span>
          </label>
        </p>
      </div> */}
      <table>
        <thead>
          <tr>
            <th>№</th>
            {/* <th>Состояние</th> */}
            <th>Дата</th>
            <th>Наименование</th>
            <th>ИНН</th>
            <th>Услуги</th>
            <th>Данные заказчика</th>
            <th>Юрист</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>

        <tbody>
          {cards.map((elem, index) => {
              // if ((elem.formed && !formed) || (!elem.formed && !notFormed)){
              //     return null
              // }
            return (
              <tr>
                <td>{index + 1}</td>
                {/* <td>
                  {" "}
                  <span
                    className={"badge" + (elem.formed ? " green" : " red")}
                  ></span>
                </td> */}
                <td style={{width:"10%"}}>{elem.date === '' ? '-' : elem.date}</td>
                <td>{(elem.formData.clientType.type === 'ф.л.' ? elem.name : elem.formData.clientType.type === 'ю.л.' ? elem.formData.clientType.name : '') === '' ? '-' : (elem.formData.clientType.type === 'ф.л.' ? elem.name : elem.formData.clientType.ofp === 'Иное' ? elem.formData.clientType.shortofp+" «"+elem.formData.clientType.name+"»" : elem.formData.clientType.ofp === 'ИП' ? elem.formData.clientType.ofp+" "+elem.formData.clientType.name : elem.formData.clientType.ofp+" «"+elem.formData.clientType.name+"»")}</td>
                <td>{elem.inn === '' ? '-' : elem.inn}</td>
                <td>{elem.uslugi.map((usluga) => {
          return GetUsluga(usluga);
        }).length === 1
          ? "-"
          : elem.uslugi
              .map((usluga) => {
                return GetUsluga(usluga);
              })
              .join(", ").slice(0, -2)}</td>
                {/* <td>{(elem.uslugi.map((usluga)=>{return <p>{GetUsluga(usluga)}</p>})).length === 1 ? '-' : (elem.uslugi.map((usluga)=>{return <p>{GetUsluga(usluga)}</p>}))}</td> */}
                <td>{elem.formData.phone === '' ? '-, ' : elem.formData.phone + ", "+ (elem.formData.email === '' ? '-' : elem.formData.email)}</td>
                <td>{elem.urist === '' ? '-' : elem.urist}</td>
                <td>
                  <NavLink
                    onClick={() =>
                      CardEdit({ ...elem.formData, _id: elem._id })
                    }
                    to={"/edit"}
                  >
                    Изменить
                  </NavLink>
                </td>
                <td>
                  <NavLink
                    onClick={() =>
                      {SaveCard(elem.formData)}
                    }
                    to={"#"}
                  >
                    Дублировать
                  </NavLink>
                </td>
                <td>
                  <NavLink
                    onClick={() =>
                      {DeleteCard(elem)}
                    }
                    to={"#"}
                  >
                    Удалить
                  </NavLink>
                </td>
                {/* <td><Link to={`/short1vz/detail/${elem._id}`}>Открыть</Link></td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
